if (!customElements.get('gf-sticky-atc')) {
  customElements.define('gf-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector('button');
      this.onClick = () => {
        const info = document.getElementById(`MainProduct-${this.dataset.section}`);
        const picker = info?.querySelector('variant-selects');
        const target = picker || info?.querySelector('product-form');
        if (!target) return;
        target.scrollIntoView({behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        const input = target.querySelector('select, input:checked, input:not([type="hidden"]), button');
        input?.focus({preventScroll: true});
      };
      this.control.addEventListener('click', this.onClick);
      this.sync = this.sync.bind(this);
      this.onScroll = () => {
        const info = document.getElementById(`MainProduct-${this.dataset.section}`);
        const original = info?.querySelector('product-form [type="submit"]');
        const show = !!original && original.getBoundingClientRect().bottom < 0;
        if (this.hidden === show) this.hidden = !show;
        document.body.classList.toggle('gf-has-sticky-atc', show);
        if (show) document.body.style.setProperty('--gf-sticky-height', `${this.offsetHeight}px`);
      };
      this.sync();
      const info = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.info = info;
      if (info) {
        info.addEventListener('change', this.sync);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(info, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      }
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }
    sync() {
      const info = document.getElementById(`MainProduct-${this.dataset.section}`);
      const original = info?.querySelector('product-form [type="submit"]');
      if (!original) return;
      const picker = info.querySelector('variant-selects');
      const values = picker ? Array.from(picker.querySelectorAll('select, input:checked'), input => input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.value).filter(Boolean) : [];
      const model = this.querySelector('.gf-sticky-atc__model');
      const label = values.join(' / ');
      if (model && model.textContent !== label) model.textContent = label;
      if (model) model.hidden = !label;
      const variantScript = info.querySelector('[data-selected-variant]');
      try {
        const variant = variantScript ? JSON.parse(variantScript.textContent) : null;
        const image = this.querySelector('img');
        const source = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
        if (source && image && image.dataset.variantSource !== source) {
          image.removeAttribute('srcset');
          image.src = source;
          image.dataset.variantSource = source;
        }
      } catch {}
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.info?.removeEventListener('change', this.sync);
      this.control?.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      document.body.classList.remove('gf-has-sticky-atc');
      document.body.style.removeProperty('--gf-sticky-height');
    }
  });
}
